import {
  Compiler,
  Component,
  ComponentFactory,
  ComponentFactoryResolver,
  ComponentRef,
  EventEmitter,
  Input,
  ModuleWithComponentFactories,
  NgModule,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "@app/modules/shared/shared.module";

@Component({
  selector: "kl-dynamic-form",
  templateUrl: "./dynamic-form.component.html",
  styleUrls: ["./dynamic-form.component.scss"],
})
export class DynamicFormComponent implements OnInit {
  @Input() module: string;
  @Input() mode: string;
  @Input() entity: any;
  @Input() isReadOnly: boolean;
  @Input() component: any;
  @Input() columns: any;
  @Output() commitSave = new EventEmitter<any>();
  @ViewChild("container", { read: ViewContainerRef, static: true })
  private container: ViewContainerRef;
  private componentRef: ComponentRef<{}>;
  template = "";
  sortableData = [];

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private compiler: Compiler
  ) {}

  ngOnInit() {
    this.renderTemplate();
    this.compileTemplate();
  }

  renderTemplate() {
    this.template =
      this.template +
      `<kl-form-container>
  <div id="filterSet" style="position: relative; display: flex;">
    <div style="margin-left: 30px;">
      <div class="btn-group" role="group" dropdown placement="bottom right">
        <button type="button"
                class="btn btn-greenish btn-sm"
                (click)="commitSave()">
          <i class="fal fa-save"></i>
          {{'save' | translate}}
        </button>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
  <form #SectorForm="ngForm" novalidate><accordion>`;
    for (let i = 0; i < this.columns.length; i++) {
      this.template = this.template + this.columns[i].html;
      for (let j = 0; j < this.columns[i].content.length; j++) {
        this.template = this.template + this.columns[i].content[j].html;
        for (let k = 0; k < this.columns[i].content[j].children.length; k++) {
          this.sortableData.push(this.columns[i].content[j].children[k]);
          this.template =
            this.template +
            this.columns[i].content[j].children[k].html +
            (this.columns[i].content[j].children[k].closeTag
              ? this.columns[i].content[j].children[k].closeTag
              : "");
        }
      }
    }
  }

  compileTemplate() {
    const metadata = {
      selector: `dynamic-form`,
      template: this.template,
    };
    const factory = this.createComponentFactorySync(
      this.compiler,
      metadata,
      null,
      this.columns
    );

    if (this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = null;
    }
    this.componentRef = this.container.createComponent(factory);
    const instance: any = this.componentRef.instance;
    if (instance) {
      instance.mode = this.mode ? this.mode : "";
      instance.entity = this.entity ? this.entity : {};
      instance.isReadOnly = this.isReadOnly ? this.isReadOnly : false;
    }
  }

  private createComponentFactorySync(
    compiler: Compiler,
    metadata: Component,
    componentClass: any,
    data
  ): ComponentFactory<any> {
    const component = componentClass || class DynamicComponent {};
    const decoratedCmp = Component(metadata)(component);

    @NgModule({
      imports: [CommonModule, SharedModule.forRoot()],
      declarations: [decoratedCmp],
    })
    class DynamicFormModule {}

    const module: ModuleWithComponentFactories<any> =
      compiler.compileModuleAndAllComponentsSync(DynamicFormModule);
    return module.componentFactories.find(
      (f) => f.componentType === decoratedCmp
    );
  }
}
